export enum TEFReceiptPrintTargetEnum {
  Customer = 'CUSTOMER',
  Establishment = 'ESTABLISHMENT',
}

export enum TEFReceiptPrintTypeEnum {
  Thermal = 'THERMAL',
  A4 = 'A4',
}
